import { DOCUMENTS_EXTENSION } from '@common/constants/general/path';

export const PERMITTED_UPLOAD_FILE_EXTENSIONS = [DOCUMENTS_EXTENSION.xls, DOCUMENTS_EXTENSION.xlsx];
